import script from "./JaMonitorManagementRow.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMonitorManagementRow.vue?vue&type=script&setup=true&lang=js"

import "./JaMonitorManagementRow.vue?vue&type=style&index=0&id=0443587c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0443587c"]])

export default __exports__